/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="mc-carpool-item pointer" @click="goToDetailCarpool(index)">
    <div>
      <div class="mc-carpool-header d-flex justify-between align-center flex-wrap">
        <div v-if="isPunctualCarpool" class="">
          <div>
            <span>{{ getDateCarpoolItem }} </span>
          </div>
          <div class="d-flex justify-between w-100">
            <div class="mc-carpool-subheader-punctual d-flex align-center">
              <ion-icon style="margin-right: 5px;" :name="(!!carpoolSource && !!carpoolSource.type && carpoolSource.type == 2) ? 'arrow-up' :'arrow-down'"></ion-icon>
              <span class="time">{{ this.carpool.time && this.carpool.time.length > 5 ? moment(this.carpool.time, 'HH[:]mm', 'utc') : this.carpool.time }}</span>
              <span class="time" v-if="this.isSearch">{{ $t('Carpool.location', {location: this.carpool.resultDriverOrPassenger.outward.originPassenger.addressLocality })}}</span>
              <span class="time" v-else>{{ $t('Carpool.location', {location: this.carpool.origin.addressLocality })}}</span>
            </div>
            <div class="mc-carpool-subheader-punctual d-flex align-center" v-if="this.carpool.returnTime">
              <ion-icon style="margin-right: 5px;" name="arrow-up"></ion-icon>
              <span class="time">{{ this.carpool.returnTime && this.carpool.returnTime.length > 5 ? moment(this.carpool.returnTime, 'HH[:]mm', 'utc') : this.carpool.returnTime}}</span>
              <span class="time" v-if="this.isSearch">{{ $t('Carpool.location', {location: this.carpool.resultDriverOrPassenger.outward.destinationPassenger.addressLocality })}}</span>
              <span class="time" v-else>{{ $t('Carpool.location', {location: this.carpool.destination.addressLocality })}}</span>
            </div>
          </div>
        </div>

        <div v-if="!isPunctualCarpool" class="d-flex flex-wrap">
          <div v-for="(day, index) in carpool.regularDays" :key="index">
            <div class="mc-pastille-day" v-bind:class="{ 'selected': day.value }">
              <b>{{$t(day.trad)}}</b>
            </div>
          </div>
        </div>
        <div class="d-flex align-center" style="gap: 10px;">
          <div v-if="this.carpool.price">
            <span>{{ this.carpool.price }} €</span>
          </div>
          <div v-if="isSearch && carpool.matchingPercentage" class="mc-matching-badge" :class="matchingBadgeClass">
            <ion-icon name="analytics" style="margin-right: 4px;"></ion-icon>
            <span>{{ Math.round(carpool.matchingPercentage) }}%</span>
          </div>
        </div>
      </div>
      <div v-if="!isPunctualCarpool" class="mc-carpool-subheader d-flex flex-col justify-around align-center">
        <div
          v-if="this.carpool.outwardTime && !this.carpool.isMultipleTimes"
          class="d-flex align-center mc-carpool-regular-time"
        >
          <ion-icon :name="(!!carpoolSource && !!carpoolSource.type && carpoolSource.type == 2) ? 'arrow-up' :'arrow-down'"></ion-icon>
          <span>{{ (!!carpoolSource && !!carpoolSource.type && carpoolSource.type == 2) ? $t('Carpool.return') : $t('Carpool.oneWay') }}</span>
          <span class="time">{{ this.carpool.outwardTime.length > 5 ? moment(this.carpool.outwardTime, 'HH[:]mm', 'utc') : this.carpool.outwardTime }}</span>
          <span class="time" v-if="this.isSearch">{{ $t('Carpool.location', {location: this.carpool.resultDriverOrPassenger.outward.originPassenger.addressLocality })}}</span>
          <span class="time" v-else>{{ $t('Carpool.location', {location: this.carpool.origin.addressLocality })}}</span>
        </div>

        <div
          v-if="this.carpool.returnTime && !this.carpool.isMultipleTimes"
          class="d-flex align-center mc-carpool-regular-time"
        >
          <ion-icon name="arrow-up"></ion-icon>
          <span>{{ $t('Carpool.return') }}</span>
          <span class="time">{{  this.carpool.returnTime.length > 5 ? moment(this.carpool.returnTime, 'HH[:]mm', 'utc') : this.carpool.returnTime }}</span>
          <span class="time" v-if="this.isSearch">{{ $t('Carpool.location', {location: this.carpool.resultDriverOrPassenger.outward.destinationPassenger.addressLocality })}}</span>
          <span class="time" v-else>{{ $t('Carpool.location', {location: this.carpool.destination.addressLocality })}}</span>
        </div>

        <div v-if="this.carpool.isMultipleTimes" class="d-flex align-center mc-carpool-regular-time">
          <ion-icon name="arrow-up"></ion-icon>
          <ion-icon name="arrow-down"></ion-icon>
          <span>{{ $t('Carpool.multipeTimes') }}</span>
        </div>
      </div>

      <div class="mc-carpool-info d-flex align-center align-stretch">
        <div class="mc-carpool-info-image d-flex flex-col">
          <div v-if="this.carpool.driver" class="mc-carpool-driver">
            <ion-icon size="large" name="car"></ion-icon>
          </div>
          <div v-if="this.carpool.passenger" class="mc-carpool-passenger">
            <ion-icon size="large" name="walk"></ion-icon>
          </div>
        </div>
        <div>
          <div v-if="this.carpoolSource && this.carpoolSource.solidaryExclusive" class="text-center">
            <small>{{$t('Carpool.solidaryExclusive')}}</small>
          </div>

          <div class="d-flex mc-carpool-way">
            <div class="mc-carpool-time" v-if="isPunctualCarpool">
              <p v-if="carpool.outwardTime">{{ carpool.outwardTime.length > 5 ? moment(carpool.outwardTime , 'HH[:]mm', 'utc' ) : carpool.outwardTime}}</p>
              <p v-if="carpool.outwardEndTime">{{ carpool.outwardEndTime.length > 5 ? moment(carpool.outwardEndTime , 'HH[:]mm', 'utc' ) : carpool.outwardEndTime }}</p>
            </div>
            <div class="mc-carpool-origin-destination">
              <div v-if="this.isSearch">
                <span v-if="carpool.driver">
                  <p class="timeline">{{this.formatAddress(this.carpool.resultDriverOrPassenger.outward.originDriver, true)}}</p>
                  <p class="timeline">{{this.formatAddress(this.carpool.resultDriverOrPassenger.outward.destinationDriver, true)}}</p>
                </span>
                <span v-if="!carpool.driver && carpool.passenger">
                  <p class="timeline">{{this.formatAddress(this.carpool.resultDriverOrPassenger.outward.originPassenger, true)}}</p>
                  <p class="timeline">{{this.formatAddress(this.carpool.resultDriverOrPassenger.outward.destinationPassenger, true)}}</p>
                </span>
              </div>
              <div v-else>
                <p class="timeline">{{this.formatAddress(this.carpool.origin, true)}}</p>
                <p class="timeline">{{this.formatAddress(this.carpool.destination, true)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="mc-carpool-footer">
      <div v-if="this.carpool.carpooler && (type == 'search' || type == 'accepted' )" class="d-flex justify-between align-center">
        <!-- $router.push({name : 'profile-public', params : {id: carpool.carpooler.id }}) -->
        <a href="javascript:void(0)" style="text-decoration: auto">
          <div class="d-flex align-center">
            <ion-thumbnail class="position-relative">
              <img
                v-if="checkAvatarDefault"
                :hidden="!(this.carpool.carpooler.avatar && this.avatarLoaded)"
                :src="webURL + this.carpool.carpooler.avatar"
                @load="onImgLoad()"
                alt=""
              />
              <img v-else :src="this.carpool.carpooler.avatar" alt=""
                :hidden="!(this.carpool.carpooler.avatar && this.avatarLoaded)"
                @load="onImgLoad()"
              />
              <ion-icon v-if="showExperienced && this.carpool.carpooler.experienced" class="experienced" name="star"></ion-icon>
              <!--<ion-icon v-if="! this.avatarLoaded" name="contact" size="large"></ion-icon>-->
            </ion-thumbnail>
            <strong
              class="mc-carpool-carpooler"
            >{{this.carpool.carpooler.givenName}} {{this.carpool.carpooler.shortFamilyName}}</strong>
            <!-- Verified Identity -->
            <div v-if="verifiedIdentity && this.carpool.carpooler.verifiedIdentity" class="mc-verified-identity">
              <svg height="20px" viewBox="0 0 24 24" width="20px"><g>
                <path fill="var(--ion-color-success)" d="M13,13c0,1,0.5,1.8,1.2,2.4C12.3,16.1,11,17.9,11,20h10c0-2.1-1.3-3.9-3.2-4.6C18.5,14.8,19,14,19,13c0-1.7-1.3-3-3-3   S13,11.3,13,13z M19.9,19h-7.7c0.4-1.7,2-3,3.9-3S19.4,17.3,19.9,19z M18,13c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S18,11.9,18,13z"/>
                <rect fill="var(--ion-color-success)" height="1" width="5" x="4" y="17"/>
                <rect fill="var(--ion-color-success)" height="1" width="5" x="4" y="15"/>
                <rect fill="var(--ion-color-success)" height="1" width="5" x="4" y="13"/>
                <path fill="var(--ion-color-success)" d="M23,6h-9V3c0-0.6-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1v3H1C0.4,6,0,6.4,0,7v16c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V7   C24,6.4,23.6,6,23,6z M11,3h2v6h-2V3z M22,22H2V8h8v1c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V8h8V22z"/></g>
              </svg>
            </div>
            <!-- Badges -->
            <div v-if="displayBadge && this.carpool.carpooler.numberOfBadges" class="mc-carpool-badge">
              <div class="mc-carpool-badge-image">
                <img style="width:40px;" src="/assets/badge-null.png"/>
              </div>
              <div class="mc-carpool-badge-text">
                <span><strong>{{this.carpool.carpooler.numberOfBadges}}</strong></span>
              </div>
            </div>
          </div>
        </a>
        <ion-icon
          v-if="type == 'accepted'"
          size="large"
          color="primary"
          name="chatbubbles"
          class="mc-user-chat"
          v-on:click="goToDetailCarpool(index)"
        ></ion-icon>
        <div v-if="this.carpool.carpooler.telephone && (this.carpool.carpooler.phoneDisplay == 2 || this.carpool.acceptedAsk)">
          <ion-fab-button :href="'tel:' + carpool.carpooler.telephone" target="_self" style="height: 40px; width: 40px;">
            <ion-icon name="call"></ion-icon>
          </ion-fab-button>
        </div>
        <div v-if="this.carpool.communityImages && this.carpool.communityImages.length > 0">
          <span v-for="c in this.carpool.communityImages">
            <ion-thumbnail>
              <img :src="c[0].versions.square_250" />
            </ion-thumbnail>
          </span>
        </div>
        <div v-if="this.carpool.externalOrigin">
          {{this.carpool.externalOrigin}}
        </div>
      </div>
      <div v-if="type == 'my-carpool'">
        <div class="ion-text-start">
          <div
            v-if="carpool.dateValidity"
          >{{$t("MyCarpools.validatedUntil")}} {{moment(carpool.dateValidity, 'dddd D[.]MM[.]YYYY', 'utc')}}</div>
        </div>

        <div class="d-flex align-center justify-end" style="flex-flow: wrap">
          <ion-button
            class="mc-small-button"
            color="primary"
            :class="{ disabled: (!!carpoolSource.type && carpoolSource.type == 2) }"
            v-if="hasNoAcceptedAsk(carpoolSource)"
            @click="updateCarpool(carpoolSource)"
          >
            <ion-icon name="create"></ion-icon>
            <span class="ion-margin-start">{{$t('Commons.update')}}</span>
          </ion-button>

          <ion-button
            class="mc-small-button"
            color="danger"
            @click="deleteCarpoolAlertConfirm(carpool, carpoolSource)"
          >
            <ion-icon name="trash"></ion-icon>
            <span class="ion-margin-start">{{$t('Commons.delete')}}</span>
          </ion-button>

          <ion-button
            v-if="carpool.frequency == 2"
            :ref="'test'"
            class="mc-small-button"
            color="primary"
            @click="pauseCarpool(carpoolSource)"
          >
            <ion-icon
              color="light"
              v-if="!carpool.paused && this.$store.getters.statusPauseCarpool != 'loading'"
              name="pause"
            ></ion-icon>
            <ion-icon
              color="light"
              v-if="carpool.paused && this.$store.getters.statusPauseCarpool != 'loading'"
              name="play"
            ></ion-icon>
            <ion-icon
              color="light"
              v-if="this.$store.getters.statusPauseCarpool == 'loading'"
              name="sync"
            ></ion-icon>
          </ion-button>
        </div>
      </div>
      <!-- end footer -->

      <div
        v-if="type == 'my-carpool'"
        class="mc-carpool-potential-carpoolers"
      >
        <ion-button
          class="mc-big-button normal-wrap"
          fill="outline"
          color="success"
          expand="block"
          :disabled="carpool.potentialCarpoolers == 0"
          @click="searchPotentialCarpoolers()"
        >{{carpool.potentialCarpoolers}} {{$t("MyCarpools.potentialCarpoolers")}}</ion-button>
      </div>
      <div
        v-if="payment && activatedPayment"
        class="mc-carpool-potential-carpoolers"
      >
        <div v-if="payment.paymentStatus === 1" class="text-center text-success"><b>{{$t("Payment.online")}}</b></div>
        <div v-if="payment.paymentStatus === 2" class="text-center text-success"><b>{{$t("Payment.direct")}}</b></div>
        <div v-if="payment.paymentStatus === 4" class="text-center text-success"><b>{{$t("Payment.paid")}}</b></div>
        <div v-if="payment.paymentStatus === 5" class="text-center text-success"><b>{{$t("Payment.validated")}}</b></div>
        <div v-if="payment.paymentStatus === 3" style="margin-bottom: 20px" class="text-center text-danger"><b>{{$t("Payment.unpaid")}}</b></div>
        <div @click="showNoPayment(carpool); $event.stopPropagation()">
          <ion-button v-if="payment.paymentStatus === 0 || payment.paymentStatus === 3"
                      :disabled="carpool.price == 0"
                      class="mc-big-button normal-wrap payment-btn"
                      fill="outline"
                      color="success"
                      expand="block"
                      @click="payCarpoolers();"
          >
            <span v-if="!this.carpool.driver">{{$t("Payment.paye")}}</span>
            <span v-if="this.carpool.driver">{{$t("Payment.validate-paye")}}</span>
            <ion-icon v-show="carpool.price == 0" slot="end" class="info-circle-payment" name="information-circle"></ion-icon>
          </ion-button>
        </div>

      </div>
      <div class="mt-10" v-if="activatedProof && type == 'accepted'">
        <div @click="proofAlert()" class="d-flex align-center" style="margin-bottom: 10px">
          <div>{{ $t('Proof.title') }}</div>
          <div class="proof-info"><ion-icon style="width: 24px; height: 24px" @click="$router.push({name: 'article', params: { id: 48 }}); $event.stopPropagation()" name="information-circle"></ion-icon></div>
        </div>
        <ion-button :disabled="buttonDisabledPickUp()" class="mc-big-button normal-wrap" fill="outline" expand="block" color="primary" @click="!classicProofId ? postProof() : putProof(true); $event.stopPropagation()">
          <ion-icon size="large" class="rotating" v-if="proofLoading" name="sync"></ion-icon>
          <span  v-if="!proofLoading">{{ $t('Proof.pick-up') }}</span>
          <span v-if="!proofLoading && getCheckProof(true)" class="checkmark"><ion-icon color="success" name="checkmark"></ion-icon></span>
        </ion-button>
        <ion-button :disabled="buttonDisabledDropOff()" class="mc-big-button normal-wrap" fill="outline" expand="block" color="primary" @click="putProof();  $event.stopPropagation()">
          <ion-icon size="large" class="rotating" v-if="proofLoading" name="sync"></ion-icon>
          <span  v-if="!proofLoading">{{ $t('Proof.drop-off') }}</span>
          <span v-if="!proofLoading && getCheckProof(false)" class="checkmark"><ion-icon color="success" name="checkmark"></ion-icon></span>
        </ion-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.mc-carpool-item {
  background: rgba(var(--ion-color-primary-rgb), 0.1);
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);
  margin-bottom: 20px;
  border-radius: 20px;

  .disabled {
    opacity: 0.5;
  }

  .mc-carpool-header {
    font-weight: bold;
    color: var(--ion-color-primary);
    padding: 20px;
  }

  .mc-carpool-subheader {
    background: rgba(255, 255, 255, 0.5);
    color: var(--ion-color-primary);
    height: 60px;
    padding: 10px;

    .mc-carpool-regular-time {
      font-weight: bold;

      span {
        padding-right: 10px;

        &.time {
          font-weight: lighter;
          color: rgba(var(--ion-color-primary-rgb), 0.7);
        }
      }
    }



  }

  .mc-carpool-subheader-punctual {
    span {
        padding-right: 7px;

        &.time {
          font-weight: lighter;
          color: rgba(var(--ion-color-primary-rgb), 0.7);
        }
      }
  }

  .mc-pastille-day {
    background: white;
    color: rgba(var(--ion-color-primary-rgb), 0.5);
    font-weight: bold;
    font-size: 14px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    margin-bottom: 5px;

    &.selected {
      background: rgba(var(--ion-color-primary-rgb), 0.5);
      color: white;
    }
  }

  .mc-carpool-info {
    background: white;
    color: var(--ion-color-primary);

    .mc-carpool-driver {
      flex: 1;
      justify-content: center;
      align-items: center;
      width: 40px;
      display: flex;
      background: var(--ion-color-success);
    }

    .mc-carpool-passenger {
      flex: 1;
      justify-content: center;
      align-items: center;
      width: 40px;
      display: flex;
      background: var(--ion-color-primary);
    }

    .mc-carpool-way {
      padding-left: 20px;

      .mc-carpool-time {
        padding-right: 10px;
      }

      .mc-carpool-origin-destination {
        font-weight: bold;

        div {
          // border-left: 2px solid red;
          padding-left: 10px;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            width: 4px;
            height: 80%;
            background-color: var(--ion-color-primary);
            top: 50%;
            transform: translateY(-50%);
            left: 4px;
          }

          .timeline {
            position: relative;
            padding-left: 10px;

            &::before {
              content: "";
              position: absolute;
              margin: auto;
              width: 12px;
              height: 12px;
              border-radius: 6px;
              background-color: var(--ion-color-primary);
              top: 0px;
              bottom: 0;
              left: -10px;
            }
          }
        }
      }
    }

    ion-icon {
      color: white;
    }
  }

  .mc-matching-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: bold;
    color: white;

    ion-icon {
      color: white;
      font-size: 14px;
    }

    &.match-high { background: var(--ion-color-success); }
    &.match-medium { background: var(--ion-color-warning); }
    &.match-low { background: var(--ion-color-danger); }
  }

  .mc-carpool-footer {
    padding: 20px;
    color: var(--ion-color-primary);

    .mc-carpool-carpooler {
      padding-left: 20px;
    }

    .mc-verified-identity {
      margin-left: 10px;
    }

    .mc-carpool-badge {
      margin-left:10px;
      margin-top:-25px;

      .mc-carpool-badge-image {
        position:absolute;
        z-index:1;
        margin-top: -7px;
      }

      .mc-carpool-badge-text {
        position:absolute;
        z-index:1;
        margin-top:0px;
        width: 40px;
        text-align: center;
        font-size:0.8rem;
        color:black;
        font-weight: bold;
      }
    }


    ion-thumbnail {
      --size: 40px;
      --border-radius: 50%;
    }

    .mc-carpool-potential-carpoolers {
      margin-top: 20px;
    }
  }

  .checkmark {
    position: absolute;
    right: 0px;
    font-size: 30px;
    top: 0px;
  }

  .info-circle-payment {
    position: absolute;
    right: 0px;
    font-size: 30px;
    top: 0px;
  }
}

  .text-success {
    color: var(--ion-color-success)
  }
  .text-danger {
    color: var(--ion-color-danger)
  }

  .mt-10 {
    margin-top: 10px;
  }

  .proof-info {
    margin-left: 5px;
    display: flex;
  }

  .w-100 {
    width: 100%;
  }

</style>


<script>
import { toast } from "../../../Shared/Mixin/toast.mixin";
import { address } from "../../../Shared/Mixin/address.mixin";
import { Device } from '@capacitor/device';
import { Geolocation } from '@capacitor/geolocation';
import {isPlatform} from "@ionic/core";
import {alertController, toastController} from "@ionic/vue";



export default {
  name: "carpool-item",
  props: ["carpool", "type", "carpoolSource", "payment", "carpoolProofId", "index", "rdex"],
  data() {
    return {
      BackgroundGeolocation: {},
      avatarLoaded: false,
      proofLoading: false,
      proof: null,
      classicProofId: this.carpoolProofId,
      activatedPayment: JSON.parse(process.env.VUE_APP_PAYMENT),
      activatedProof: JSON.parse(process.env.VUE_APP_CAN_SEE_PROOF),
      showPrime: JSON.parse(process.env.VUE_APP_MOB),
      showExperienced: JSON.parse(process.env.VUE_APP_EXPERIENCED),
      verifiedIdentity: JSON.parse(process.env.VUE_APP_VERIFIED_IDENTITY),
      isSearch: this.type == 'search' ? true : false,
      displayBadge: JSON.parse(process.env.VUE_APP_BADGES),
      detectFakeGPS: JSON.parse(process.env.VUE_APP_DETECT_FAKE_GPS),
      webURL: process.env.VUE_APP_WEB_URL
    };
  },
  mixins: [toast, address],
  mounted() {
    if(this.carpool.community && this.carpool.community.length > 0) {
      this.carpool.communityImages = []
      this.carpool.community.forEach(c => {
        this.$store.dispatch("getCommunityImages", c).then(res => {
          this.carpool.communityImages.push(res.data['hydra:member']);
          this.$forceUpdate();
        })
      });
    }

    if (this.classicProofId) {
      this.getProof();
    }
  },
  created() {
    if (!!this.carpool.carpooler && !!this.carpool.carpooler.classicProof) {
      this.classicProofId = this.carpool.carpooler.classicProof.id;
    }
    if (isPlatform(window.document.defaultView, "capacitor")) {
      document.addEventListener('deviceready', () => {
        this.importBackgroundGeolocation();
      }, false);
    }
  },
  computed: {
    getDateCarpoolItem() {
      return this.$moment(this.carpool.date).format("dddd D[.]MM");
    },

    isPunctualCarpool() {
      return this.carpool.frequency == 1;
    },

    matchingBadgeClass() {
      const p = this.carpool.matchingPercentage;
      if (p >= 80) return 'match-high';
      if (p >= 50) return 'match-medium';
      return 'match-low';
    },
    checkAvatarDefault() {
      if(this.carpool.carpooler.avatar=== undefined ){
        return false;
      }
      const path = this.carpool.carpooler.avatar;
      const avatarDefaultPath = '/images/avatarsDefault/square_100.svg'
      if (path.includes(avatarDefaultPath)) {
        return true;
      }
    }
  },
  methods: {
    importBackgroundGeolocation() {
      import("cordova-background-geolocation-plugin")
        .then(module => {
          // Module is successfully imported, you can now use it
          this.BackgroundGeolocation = module;
          // Use BackgroundGeolocation here...
          this.BackgroundGeolocation.configure({
            desiredAccuracy: this.BackgroundGeolocation.DESIRED_ACCURACY_HIGH
          })
        })
        .catch(error => {
          // Handle any errors that occur during the import
          console.error("Error importing BackgroundGeolocation:", error);
        });
    },
    deleteCarpoolAlertConfirm(carpool, carpoolSource) {
      console.log(carpoolSource);
      return alertController
        .create({
          header: this.$t("MyCarpools.confirmDeleteHeader"),
          message: this.$t(carpool.asks && (carpoolSource.passengers.length > 0 || carpoolSource.driver.length > 0 )  ? (carpool.passenger ? "MyCarpools.confirmDeleteTextPassenger" : "MyCarpools.confirmDeleteTextDriver") : "MyCarpools.confirmDeleteText"),
          inputs: carpool.asks ? [
             {
              name: 'message',
              placeholder: 'Message'
            }
          ] : [],
          buttons: [
            {
              text: this.$t("Commons.cancel"),
              role: "cancel",
              cssClass: "secondary"
            },
            {
              text: this.$t("Commons.confirm"),
              handler: (data) => {
                const carpoolParams = {
                  "deleterId": this.$store.state.userStore.user.id,
                  "deletionMessage":  !!data ? data.message : ''
                }
                this.deleteCarpool(carpool.id, carpoolParams);
              }
            }
          ]
        })
        .then(a => a.present());
    },
    deleteCarpool(carpoolId, carpoolParams) {
      this.$store
        .dispatch("deleteCarpool", carpoolId, carpoolParams)
        .then(res => {
          this.presentToast(
            this.$parent.$t("MyCarpools.delete-success"),
            "success"
          );

          fetch(process.env.VUE_APP_FIRE_DELETE_EVENT_URL + '?proposalId=' + (carpoolId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('tokenUser') || localStorage.getItem('tokenAnonymousUser')}`,
            },
          }).then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
          })

        })
        .catch(err => {
          this.presentToast(this.$parent.$t("Commons.error"), "danger");
        });
    },
    onImgLoad: function() {
      this.avatarLoaded = true;
    },

    pauseCarpool(carpoolSource) {
      const carpool = Object.assign({}, carpoolSource)

      const payload = {
        origin: carpool.waypoints[0],
        destination: carpool.waypoints[carpool.waypoints.length - 1],
        step: carpool.waypoints.length > 2 ? carpool.waypoints.slice(1, carpool.waypoints.length - 1) : [],
        outwardDate: carpool.outwardDate,
        frequency: carpool.frequency
      };

      carpool.oneWay = (!!carpool.returnWaypoints && carpool.returnWaypoints.length > 0) ? false : true;
      carpool.role = (carpool.roleDriver && carpool.rolePassenger) ? 3 : (carpool.rolePassenger ? 2 : 1);
      carpool.seatsDriver = carpool.seats;
      carpool.paused =  !carpool.paused

      this.$store.commit("carpoolPost_update", carpool);
      this.$store.commit("carpoolPost_fromSearch", payload);
      if (payload.origin || payload.outwardDate) {
        this.$store.dispatch("treatementUpdateAddresses", {noPriceChange: true});
      }

      let filters = {};

      this.$store
        .dispatch("updateCarpool", payload)
        .then(resp => {
          this.presentToast(
            this.$parent.$t("MyCarpools.pause-success"),
            "success"
          );

          this.carpoolSource.paused = resp.data.paused;
          this.carpool.paused = resp.data.paused;
          this.$forceUpdate();
        })
        .catch(err => {
          this.presentToast(this.$parent.$t("Commons.error"), "danger");
        });
      /*
      const payload = {
        carpoolId : this.carpool.id,
        data: {
          paused: !this.carpool.paused,
          adId: this.carpool.id
        }
      };

      this.$store
        .dispatch("pauseCarpool", payload)
        .then(resp => {
          this.presentToast(
            this.$parent.$t("MyCarpools.pause-success"),
            "success"
          );

          this.carpool.paused = resp.data.paused;
          this.$forceUpdate();
        })
        .catch(err => {
          this.presentToast(this.$parent.$t("Commons.error"), "danger");
        });
       */
    },

    searchPotentialCarpoolers() {
      let addressDTOOrigin = this.carpool.origin;
      const displayGeoOrigin = this.formatAddress(addressDTOOrigin)
      let addressDTODestination = this.carpool.destination;
      const displayGeoDestination = this.formatAddress(addressDTODestination)
      this.$store.commit("changeOrigin", {
        addressDTO: addressDTOOrigin,
        displayGeo: displayGeoOrigin
      });
      this.$store.commit("changeDestination", {
        addressDTO: addressDTODestination,
        displayGeo: displayGeoDestination
      });

      this.$store.state.searchStore.searchObject.frequency = this.carpool.frequency;
      this.$store.state.searchStore.searchObject.adId = this.carpool.id;
      this.$router.push({ name: "search" });
    },
    hasNoAcceptedAsk(carpool){
      let res = true;
      if (carpool.results) {
        carpool.results.forEach(item => {
          if ( item.acceptedAsk ) {
            res = false;
          }
        });
      }
      return res;
    },
    updateCarpool(carpool) {
      if (carpool.type == 2) {
        this.presentToast(
          "Pour modifier ce trajet, veuillez modifier l'aller associé",
          "warning"
        );
        return;
      }

      const payload = {
        origin: carpool.waypoints[0],
        destination: carpool.waypoints[carpool.waypoints.length - 1],
        step: carpool.waypoints.length > 2 ? carpool.waypoints.slice(1, carpool.waypoints.length - 1) : [],
        outwardDate: carpool.outwardDate,
        frequency: carpool.frequency
      };

      carpool.oneWay = (!!carpool.returnWaypoints && carpool.returnWaypoints.length > 0) ? false : true;
      carpool.role = (carpool.roleDriver && carpool.rolePassenger) ? 3 : (carpool.rolePassenger ? 2 : 1);
      carpool.seatsDriver = carpool.seats;

      this.$store.commit("carpoolPost_update", carpool);
      this.$store.commit("carpoolPost_fromSearch", payload);
      if (payload.origin || payload.outwardDate) {
        this.$store.dispatch("treatementUpdateAddresses", {noPriceChange: true});
      }

      let filters = {};
      this.$router.push({name: "post-carpool", params: {filters}});
    },
    call(telephone) {
      window.location.href ="tel:" + telephone;
    },
    payCarpoolers() {
      this.$router.push({ name: 'payment', query : {
          frequency: this.carpool.frequency,
          type: this.carpool.driver ? 2 : 1,
          week: this.payment.paymentItemWeek,
          defaultId: this.payment.paymentItemId,
          askId: this.payment.askId
        }})
    },
    proofAlert() {
      this.presentToast(
        this.$t("AcceptedCarpools.proof-info"),
        "secondary"
      );
    },
    getProof() {
      this.$store.dispatch("getClassicProof", this.classicProofId).then(res => {
        this.proof = res.data;
      });
    },
    async postProof() {
      this.proofLoading = true;
      try {
        let coordinates
        if (isPlatform(window.document.defaultView, "capacitor") && this.detectFakeGPS) {
          coordinates = await this.BackgroundGeolocation.getCurrentLocation(
            null, error => {
              this.presentToast('Veuillez activer votre GPS', 'danger')
              this.proofLoading = false;
            },
            {enableHighAccuracy: true}
          )
        } else {
          coordinates = (await Geolocation.getCurrentPosition()).coords;
        }

        if (coordinates) {
          if (isPlatform(window.document.defaultView, "capacitor") && this.detectFakeGPS && coordinates.provider == "network") {
            this.presentToast('La position géographique est retournée par votre réseau. Nous avons besoin de la position GPS pour fonctionner. Coupez/Réactivez votre GPS et réessayez.', 'danger')
            this.proofLoading = false;
            return
          }
          if (isPlatform(window.document.defaultView, "capacitor") && this.detectFakeGPS && coordinates.isFromMockProvider) {
            this.presentToast('La position géographique retournée est détectée comme issue d\'un émulateur GPS et ne peut être acceptée. Couper votre émulateur GPS et réessayer.', 'danger')
            this.proofLoading = false;
            return
          }
          const params = { askId: this.carpool.carpooler.askId, latitude: coordinates.latitude.toString() , longitude: coordinates.longitude.toString()}
          const phoneId = (await Device.getInfo()).uuid
          if (this.carpool.driver) {
            params.driverPhoneUniqueId = phoneId
          } else {
            params.passengerPhoneUniqueId = phoneId
          }

          this.$store.dispatch("postClassicProof", params).then(res => {
            this.classicProofId = res.data.id;
            this.getProof();
            this.proofLoading = false;
            if (this.showPrime) {
              this.presentToast(this.$parent.$t("Commons.info-time-between"), "success");
            } else {
              this.presentToast(this.$parent.$t("Proof.pick-up-sent"), "success");
            }
          }).catch(error => {
            this.proofLoading = false;
            if (error.response.data['hydra:description'].includes('time between')) {
              this.getProof();
              this.presentToast(this.$parent.$t("Commons.error-passenger-time-between"), "warning");
            } else if (error.response.data['hydra:description'].includes('too far')) {
              this.presentToast(this.$parent.$t("Commons.error-too-far"), "danger");
            } else {
              this.presentToast(this.$parent.$t("Commons.error"), "danger");
            }
          });
        } else {
          this.proofLoading = false;
          this.locationErrorToast()
        }
      } catch (error) {
        console.log('error');
        console.log(error);
        this.proofLoading = false;
        this.locationErrorToast()
      }
    },
    async putProof(pickUp = false) {
      this.proofLoading = true;
      try {

        let coordinates
        if (isPlatform(window.document.defaultView, "capacitor") && this.detectFakeGPS) {
          coordinates = await this.BackgroundGeolocation.getCurrentLocation(
            null, error => {
              this.presentToast('Veuillez activer votre GPS', 'danger')
              this.proofLoading = false;
            },
            {enableHighAccuracy: true}
          )
        } else {
          coordinates = (await Geolocation.getCurrentPosition()).coords;
        }

        if (coordinates) {
          if (isPlatform(window.document.defaultView, "capacitor") && this.detectFakeGPS && coordinates.provider == "network") {
            this.presentToast('La position géographique est retournée par votre réseau. Nous avons besoin de la position GPS pour fonctionner. Coupez/Réactivez votre GPS et réessayez.', 'danger')
            this.proofLoading = false;
            return
          }
          if (isPlatform(window.document.defaultView, "capacitor") && this.detectFakeGPS && coordinates.isFromMockProvider) {
            this.presentToast('La position géographique retournée est détectée comme issue d\'un émulateur GPS et ne peut être acceptée. Couper votre émulateur GPS et réessayer.', 'danger')
            this.proofLoading = false;
            return
          }
          const params = { id: this.classicProofId, latitude: coordinates.latitude.toString(), longitude: coordinates.longitude.toString()};
          const phoneId = (await Device.getInfo()).uuid
          if (this.carpool.driver) {
            params.driverPhoneUniqueId = phoneId
          } else {
            params.passengerPhoneUniqueId = phoneId
          }
          this.$store.dispatch("putClassicProof", params).then(res => {
            this.proofLoading = false;
            this.getProof();
            if (this.proof.status.endsWith('00') && this.showPrime) {
              this.presentToast(this.$parent.$t("Commons.info-time-between"), "success");
            } else {
              this.presentToast(this.$parent.$t(`Proof.${pickUp ? 'pick-up' : 'drop-off'}-sent`), "success");
            }
            this.alertCEE();

          }).catch(error => {
            this.proofLoading = false;
            console.log(error)
            if (error.response.data['hydra:description'].includes('time between')) {
              this.getProof();
              this.presentToast(this.$parent.$t("Commons.error-passenger-time-between"), "warning");
            } else if (error.response.data['hydra:description'].includes('too far')) {
              this.presentToast(this.$parent.$t("Commons.error-too-far"), "danger");
            } else {
              this.presentToast(this.$parent.$t("Commons.error"), "danger");
            }
          });
        } else {
          this.proofLoading = false;
          this.locationErrorToast()
        }
      } catch (error) {
        console.log('error');
        console.log(error);
        this.proofLoading = false;
        this.locationErrorToast()
      }
    },
    alertCEE() {
      if (!this.$store.state.userStore.user.bankingIdentityStatus || !this.carpool.carpooler.bankingIdentityStatus) {
        let text = this.$t("Prime.eec-alert")
        if ((!!this.carpool.driver ? (this.$store.state.userStore.user.eecStatus && !this.carpool.carpooler.bankingIdentityStatus ) : (this.carpool.carpooler.eecStatus && !this.$store.state.userStore.user.bankingIdentityStatus))) {
          text = this.$t("Prime.eec-alert-passenger")
        }

        alertController
          .create({
            message: text,
            buttons: [
              {
                text: 'Fermer',
                role: "cancel",
              },
            ]
          })
          .then(a => a.present());
      }
    },
    goToDetailCarpool(index) {
      if (this.rdex) {
        this.$router.push({ name: 'rdex-detail', params: { param: index } });
      } else if (this.type == 'search') {
        this.$router.push({ name: 'carpool-detail', params: { param: index } });
      } else if (this.type == 'accepted') {
        const messages = this.$store.state.messageStore.messagesCarpool;
        if (messages && messages.length > 0) {
          this.$router.push({
            name: "message",
            params: {
              idAsk: this.carpool.carpooler.askId,
              idRecipient: this.carpool.carpooler.id
            }
          });
        } else {
          this.$router.push({
            name: "messages",
          });
        }
      }
    },
    buttonDisabledPickUp() {
      if (this.proof && this.classicProofId) {
        if (this.carpool.driver && this.proof.status.startsWith("10")){
          return false;
        }
        if (this.carpool.passenger && this.proof.status.startsWith("01")){
          return false;
        }
      }
      if (this.classicProofId) {
        return true;
      } else {
        return false;
      }
    },
    getCheckProof(pickUp) {
      if (this.proof && this.classicProofId) {
        if (pickUp) {
          if (this.carpool.driver && this.proof.status.charAt(1) == "1") {
            return true
          } else if (this.carpool.passenger && this.proof.status.charAt(0) == "1") {
            return true
          }
        } else {
          if (this.carpool.driver && this.proof.status.charAt(3) == "1") {
            return true
          } else if (this.carpool.passenger && this.proof.status.charAt(2) == "1") {
            return true
          }
        }
      } else {
        return false;
      }
    },
    showNoPayment(carpool) {
      if (carpool.price == 0) {
        this.presentToast('Covoiturage gratuit: ne peut être payé', 'danger')
      }
    },
    buttonDisabledDropOff() {
      if (this.proof && this.classicProofId) {
        //driver pickup proof
        if (this.carpool.driver && this.proof.status === "0100"){
          return false;
        }
        if (this.carpool.passenger && this.proof.status === "0100"){
          return true;
        }
        //driver pickup and drop off proof
        if(this.carpool.driver && this.proof.status === "0101"){
          return true;
        }
        if(this.carpool.passenger && this.proof.status === "0101"){
          return true;
        }
        //passenger pickup proof
         if(this.carpool.passenger && this.proof.status === "1000"){
          return false;
        }
        if(this.carpool.driver && this.proof.status === "1000"){
          return true;
        }
        // passenger pickup and dropoff proof
        if(this.carpool.passenger && this.proof.status === "1010"){
          return true;
        }
        if (this.carpool.driver && this.proof.status === "1010"){
          return true;
        }
        // passenger and driver pickup proof
        if(this.proof.status === "1100"){
          return false;
        }
        // passenger and driver pickup proof and driver dropoff proof
        if(this.carpool.driver && this.proof.status === "1101"){
          return true;
        }
        if(this.carpool.passenger && this.proof.status === "1101"){
          return false;
        }
         // passenger and driver pickup proof and passenger dropoff proof
        if(this.carpool.driver && this.proof.status === "1110"){
          return false;
        }
        if(this.carpool.passenger && this.proof.status === "1110"){
          return true;
        }
        return true;
      } else {
        return true;
      }
    }
  }
};
</script>
